module.exports = __webpack_public_path__ + "static/img/icon_black_gold.0a953cea.png";